import React from 'react'
import "./Photo.min.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';
const Photo = () => {
  const test = () => {
    console.log("b")
  }
  return (
    <div className='photo'>
      <Link to='..'> <FontAwesomeIcon id='faArrowLeft' icon={faArrowLeft} /></Link>
      <span id='title'>Photo</span>
      <footer>
        <button type='button' onClick={() => test()} id='circle'><p>+</p></button>
      </footer>
    </div>
  )
}

export default Photo